module.exports = __webpack_public_path__ + "static/media/Steve.fed99701.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Steve.png
// module id = 433
// module chunks = 0